
// Navigation configuration for the website
// Slugs are configured on the BE 
export const navigationConfig: Array<{
  id: string
  nameInMenu: string
  path: string
}> = [
  {
    id: 'home',
    nameInMenu: 'Home',
    path: '/',
  },
  {
    id: 'instructions',
    nameInMenu: 'Instructions',
    path: '/instructions',
  },
  {
    id: 'collections',
    nameInMenu: 'Collections',
    path: '/collections',
  },
  {
    id: 'takeaways',
    nameInMenu: 'Takeaways',
    path: '/takeaways',
  },
  {
    id: 'videos',
    nameInMenu: 'Videos',
    path: '/videos',
  },
]

// Helper function to find navigation item by path
export const findNavigationItemByPathname = (pathname: string) => {
  return navigationConfig.find(item => item.path === pathname)
}
